module.exports = __webpack_public_path__ + "static/media/oportunidades_card.94998b24.png";